import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { Page } from "../types";

const STORAGE_KEY = "testagent_pages_v1";

function uid() { return Math.random().toString(36).slice(2, 10); }

const DEFAULT_PAGES: Page[] = [
  {
    id: uid(),
    name: "Login",
    isLogin: true,
    attrs: { Buttons: true, Links: false, Input_fields: true },
    page_fuzzing: false,
    selectors: ["#username", "#password", "#login"],
    user_cases: [],
    depends_on: [],
    login: {
      Error: { Username: "", Password: "" },
      Success: { Username: "", Password: "" },
    },
  },
  {
    id: uid(),
    name: "Dashboard",
    isLogin: false,
    attrs: { Buttons: true, Links: true, Input_fields: true },
    page_fuzzing: false,
    selectors: ["#date_picker"],
    user_cases: [],
    depends_on: ["Login"],
  },
];

type Ctx = {
  pages: Page[];
  setPages: React.Dispatch<React.SetStateAction<Page[]>>;
};

const PagesContext = createContext<Ctx | null>(null);

export function PagesProvider({ children }: { children: React.ReactNode }) {
  const [pages, setPages] = useState<Page[]>(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : DEFAULT_PAGES;
    } catch { return DEFAULT_PAGES; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pages));
  }, [pages]);

  const value = useMemo(() => ({ pages, setPages }), [pages]);
  return <PagesContext.Provider value={value}>{children}</PagesContext.Provider>;
}

export function usePages() {
  const ctx = useContext(PagesContext);
  if (!ctx) throw new Error("usePages must be used within PagesProvider");
  return ctx;
}
